import { ColumnDef, ExpandedState } from "@tanstack/react-table";
import TableInfiniteScrolling, {
  TableInfiniteScrollingProps,
} from "components/common/TableInfiniteScrolling";
import { TableContainer } from "./style";

interface IColumnPinning {
  left: string[];
  right: string[];
}

// const columnPinning = {
//   left: ["select", "firstName", "lastName"],
//   right: ["createdAt"],
// };

interface ViewTableProps extends TableInfiniteScrollingProps {
  columnPinning?: IColumnPinning;
  data: any;
  columns: ColumnDef<any>[];
  handleFetchMore: () => void;
  height?: number | string;
  messageEmpty?: string | React.ReactNode;
  handleOnClickedRow?: (item: any) => void;
  handleSelection?: (item: any) => void;
  validateEnableRowSelection?: (row?: any) => boolean;
  isSelected?: boolean;
  isHasMore?: boolean;
  expanded?: ExpandedState;
}

const ViewTable = ({
  columnPinning = { left: [], right: [] },
  data,
  columns,
  handleFetchMore,
  height = 600,
  messageEmpty,
  handleOnClickedRow,
  handleSelection,
  isSelected,
  validateEnableRowSelection,
  isHasMore,
  expanded,
}: ViewTableProps) => {
  return (
    <TableContainer height={height} width="100%">
      <TableInfiniteScrolling
        fetchMore={handleFetchMore}
        columns={columns}
        dataTable={data}
        rowSelected={handleSelection}
        onClickRow={(row) => {
          handleOnClickedRow(row.original);
        }}
        columnPinning={columnPinning}
        messageEmpty={messageEmpty}
        isSelected={isSelected}
        validateEnableRowSelection={validateEnableRowSelection}
        isHasMore={isHasMore}
        expanded={expanded}
      />
    </TableContainer>
  );
};

export default ViewTable;
